export default __webpack_public_path__ + "static/media/slider1.57953e4d.jpg";